// jQuery removed — all vanilla JS now.
// (The slick-based ".trustpilot_review_right" carousel lived only on the unused
//  product2 template and is dropped along with jQuery/slick.)

document.addEventListener('DOMContentLoaded', function () {
  // On mobile, move the review details below the add-to-cart button.
  function reorderDivs() {
    if (window.innerWidth <= 767) {
      var rd = document.querySelector('.review_details');
      var atc = document.querySelector('.atc-buuton');
      if (rd && atc) { atc.insertAdjacentElement('afterend', rd); }
    }
  }
  reorderDivs();
  window.addEventListener('resize', reorderDivs);
});

document.addEventListener('DOMContentLoaded', function () {
  const url = new URL(window.location.href);

  // Strip ?sort_by=best-selling on collection pages (redirect to clean URL).
  if (url.pathname.includes('/collections/')) {
    if (url.searchParams.get('sort_by') === 'best-selling') {
      url.searchParams.delete('sort_by');
      window.location.href = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-btn');

  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      const wrapper = this.closest('.custom-tabs');

      wrapper.querySelectorAll('.tab-btn').forEach(btn => {
        btn.classList.remove('active');
      });

      wrapper.querySelectorAll('.tab-content').forEach(content => {
        content.classList.remove('active');
      });

      this.classList.add('active');

      const target = document.getElementById(this.dataset.tab);
      if (target) {
        target.classList.add('active');
      }
    });
  });
});